export const FIXED_MAX_CLP_PRICE = "fixed-max-clp-price";
export const FIXED_MAX_UF_PRICE = "fixed-max-uf-price";
export const INSURANCE_BY_KM_ATTRIBUTE_MAXKMS = "max-km";
export const INSURANCE_BY_KM_ATTRIBUTE_VARIABLE = "variable-clp-price";
export const INSURANCE_BY_KM_ENTITY_CODE = "fixed-clp-price";
export const LEGAL_REPRESENTATIVE_ATTR = "legal-representative";
export const NEW_CAR_ATTRIBUTE_CODE = "new-car";
export const NEW_CHECKOUT = "new-checkout";
